(() => {
  if (window.LumaluxStickyGallery) return;
  const instances = new Map();

  class StickyGallery {
    constructor(product) {
      this.product = product;
      this.gallery = product.querySelector(':scope > ' + (product.dataset.stickyGalleryMedia || '.product-gallery'));
      this.details = product.querySelector(':scope > .product-content-below-gallery');
      this.media = matchMedia('(min-width: ' + (product.dataset.stickyGalleryBreakpoint || '1000') + 'px)');
      this.galleryAnchor = document.createComment('gallery position');
      this.gallery.before(this.galleryAnchor);
      if (this.details) {
        this.detailsAnchor = document.createComment('gallery details position');
        this.details.before(this.detailsAnchor);
      }
      // Reuse the theme's tall-column handling and header offset.
      this.column = document.createElement('safe-sticky');
      this.column.className = 'lumalux-gallery-column';
      this.update = this.update.bind(this);
      this.media.addEventListener('change', this.update);
      this.update();
    }
    update() {
      if (this.media.matches) {
        this.product.classList.add('product--sticky-gallery');
        if (!this.column.isConnected) this.galleryAnchor.after(this.column);
        this.column.append(this.gallery);
        if (this.details) this.column.append(this.details);
      } else {
        this.restore();
      }
    }
    restore() {
      this.galleryAnchor.after(this.gallery);
      if (this.details) this.detailsAnchor.after(this.details);
      this.column.remove();
      this.product.classList.remove('product--sticky-gallery');
    }
    destroy() {
      this.media.removeEventListener('change', this.update);
      this.restore();
      this.galleryAnchor.remove();
      this.detailsAnchor?.remove();
    }
  }
  function init() {
    instances.forEach((instance, product) => {
      if (!product.isConnected || !product.hasAttribute('data-sticky-gallery')) {
        instance.destroy();
        instances.delete(product);
      }
    });
    document.querySelectorAll('[data-sticky-gallery]').forEach(product => {
      const gallerySelector = ':scope > ' + (product.dataset.stickyGalleryMedia || '.product-gallery');
      if (!instances.has(product) && product.querySelector(gallerySelector)) {
        instances.set(product, new StickyGallery(product));
      }
    });
  }
  window.LumaluxStickyGallery = { init };
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, product) => {
      if (event.target.contains(product)) {
        instance.destroy();
        instances.delete(product);
      }
    });
  });
})();
